"use client"

import { InfiniteList } from "@mylaunch/components/ui"
import { useNotifications } from "../hooks/use-notifications"
import { getNotifications } from "../server/notifications.functions"
import { NotificationCard } from "./notification-card"

export function NotificationList() {
  const { data } = useNotifications()

  return (
    <InfiniteList
      items={data.items}
      initialNextPage={data.nextPage}
      loadMore={(page) =>
        getNotifications({
          data: {
            page,
          },
        })}
      className="flex flex-col gap-s p-m"
    >
      {(n) => <NotificationCard notification={n} />}
    </InfiniteList>
  )
}
